import { motion, useAnimation } from "framer-motion";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

interface BoxProps {
    Component: React.ReactNode;
    index?: number;
    id?: string;
}

const boxVariant = {
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0 }
};

//previously box
export const PopUp: React.FC<BoxProps> = ({ Component }) => {
    const control = useAnimation();
    const [ref, inView] = useInView();
    useEffect(() => {
        if (inView) {
            control.start('visible');
        }
        else {
            control.start('hidden');
        }
    }, [control, inView]);

    return (
        <>
            <motion.div
                ref={ref}
                variants={boxVariant}
                initial="hidden"
                animate={control}
                transition={{ ease: "easeOut", duration: 0.5 }}>
                {Component}
            </motion.div>
        </>

    );
}

//previously box3. id is newly added
export const SlideWithDelay: React.FC<BoxProps> = ({ Component, index }) => {
    const [isVisible, setIsVisible] = useState(false);


    useEffect(() => {
        // Trigger visibility after a delay based on index
        if (index === undefined) return;
        const timeout = setTimeout(() => {
            setIsVisible(true);
        }, index * 400);

        return () => clearTimeout(timeout);
    }, [index]);


    return (
        <motion.div
            className="card transition-opacity duration-400 ease-in-out"
            animate={{
                opacity: isVisible ? 1 : 0,
                x: isVisible ? 0 : (index! * 50) // Adjust the offset for smoother translation
            }}
            transition={{
                opacity: { duration: 0.5, ease: 'easeOut' }, // Slowly fade in over 1 second
                x: { type: 'spring', stiffness: 50, damping: 10 } // Use spring animation for smoother translation
            }}
        >
            {Component}
        </motion.div>
    );
};

//previously box2
export const SlideFromLeft: React.FC<BoxProps> = ({ Component, index }) => {
    return (
        <>
            <motion.div
                className="card"
                initial={{
                    opacity: 0,
                    x: index! % 2 === 0 ? 50 : -50
                }}
                whileInView={{
                    opacity: 1,
                    x: 0,
                    transition: {
                        duration: 1,
                    }
                }}
                viewport={{ once: false }}
            >
                {Component}
            </motion.div>
        </>
    );
}

//previously box1
export const SlideFromRight: React.FC<BoxProps> = ({ Component, index }) => {
    return (
        <>
            <motion.div
                className="card"
                initial={{
                    opacity: 0,
                    x: index! % 2 === 0 ? -50 : 50
                }}
                whileInView={{
                    opacity: 1,
                    x: 0,
                    transition: {
                        duration: 1,
                    }
                }}
                viewport={{ once: false }}
            >
                {Component}
            </motion.div>
        </>
    );
}

